import Departments from "../components/Sections/Departments";
import Companies from "../components/Sections/Companies";
import HolidayRequestNotificationSection from "../components/Sections/HolidayRequestNotificationSection";
import SetupAdministrativSection from "../components/Sections/SetupAdministrativSection";
import ReorderGeneralConfigSections from "../components/Sections/ReorderGeneralConfigSections";
import { useUser } from "../context/UserContext";
import { hasRoleAccess } from "../utils/constants";
import { Col, Row, Typography } from "antd";

const GeneralConfiguration = () => {
  const { roles } = useUser();

  return (
    <>
      <div>
        <Typography.Title level={3}>General Configuration</Typography.Title>
      </div>
      <div className="ui divider"></div>
      {hasRoleAccess(roles, ["ADMIN", "HR"]) && (
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
            <Companies />
            </Col>
            <Col xs={24} sm={12}>
            <Departments />
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <HolidayRequestNotificationSection />
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <SetupAdministrativSection />
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <ReorderGeneralConfigSections />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default GeneralConfiguration;
